import {COLORS} from "./colors-ts";
import type {ThemeOptions} from "@mui/material";
import {createTheme, unstable_createMuiStrictModeTheme} from "@mui/material";
import type {} from '@mui/x-data-grid/themeAugmentation';
import {environment} from "../env";
import {componentOverrides} from "./overrides";

// @see: https://material-ui.com/customization/default-theme/
export const theme: ThemeOptions = {
    palette: {...COLORS},
    shape: {
        borderRadius: 8,
    },
    shadows: [
        'none', // 0
        '0 1px 3px 0 rgba(0, 0, 0, 0.12)',// 1
        '0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.20)', // 2
        '0 1px 8px 0 rgba(0, 0, 0, 0.12), 0 3px 4px 0 rgba(0, 0, 0, 0.14), 0 3px 3px -2px rgba(0, 0, 0, 0.20)', // 3
        '0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 4px 5px 0 rgba(0, 0, 0, 0.14), 0 2px 4px -1px rgba(0, 0, 0, 0.20)', // 4
        '0 1px 14px 0 rgba(0, 0, 0, 0.12), 0 5px 8px 0 rgba(0, 0, 0, 0.14), 0 3px 5px -1px rgba(0, 0, 0, 0.20)', // 5
        '0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 3px 5px -1px rgba(0, 0, 0, 0.20)', // 6
        '0 2px 16px 1px rgba(0, 0, 0, 0.12), 0 7px 10px 1px rgba(0, 0, 0, 0.14), 0 4px 5px -2px rgba(0, 0, 0, 0.20)', // 7
        '0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 5px 5px -3px rgba(0, 0, 0, 0.20)', // 8
        '0 3px 16px 2px rgba(0, 0, 0, 0.12), 0 9px 12px 1px rgba(0, 0, 0, 0.14), 0 5px 6px -3px rgba(0, 0, 0, 0.20)', // 9
        '0 4px 18px 3px rgba(0, 0, 0, 0.12), 0 10px 14px 1px rgba(0, 0, 0, 0.14), 0 6px 6px -3px rgba(0, 0, 0, 0.20)', // 10
        '0 4px 20px 3px rgba(0, 0, 0, 0.12), 0 11px 15px 1px rgba(0, 0, 0, 0.14), 0 6px 7px -4px rgba(0, 0, 0, 0.20)', // 11
        '0 5px 22px 4px rgba(0, 0, 0, 0.12), 0 12px 17px 2px rgba(0, 0, 0, 0.14), 0 7px 8px -4px rgba(0, 0, 0, 0.20)', // 12
        '0 5px 24px 4px rgba(0, 0, 0, 0.12), 0 13px 19px 2px rgba(0, 0, 0, 0.14), 0 7px 8px -4px rgba(0, 0, 0, 0.20)', // 13
        '0 5px 26px 4px rgba(0, 0, 0, 0.12), 0 14px 21px 2px rgba(0, 0, 0, 0.14), 0 7px 9px -4px rgba(0, 0, 0, 0.20)', // 14
        '0 6px 28px 5px rgba(0, 0, 0, 0.12), 0 15px 22px 2px rgba(0, 0, 0, 0.14), 0 8px 9px -5px rgba(0, 0, 0, 0.20)', // 15
        '0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 8px 10px -5px rgba(0, 0, 0, 0.20)', // 16
        '0 6px 32px 5px rgba(0, 0, 0, 0.12), 0 17px 26px 2px rgba(0, 0, 0, 0.14), 0 8px 11px -5px rgba(0, 0, 0, 0.20)', // 17
        '0 7px 34px 6px rgba(0, 0, 0, 0.12), 0 18px 28px 2px rgba(0, 0, 0, 0.14), 0 9px 11px -5px rgba(0, 0, 0, 0.20)', // 18
        '0 7px 36px 6px rgba(0, 0, 0, 0.12), 0 19px 29px 2px rgba(0, 0, 0, 0.14), 0 9px 12px -6px rgba(0, 0, 0, 0.20)', // 19
        '0 8px 38px 7px rgba(0, 0, 0, 0.12), 0 20px 31px 3px rgba(0, 0, 0, 0.14), 0 10px 13px -6px rgba(0, 0, 0, 0.20)', // 20
        '0 8px 40px 7px rgba(0, 0, 0, 0.12), 0 21px 33px 3px rgba(0, 0, 0, 0.14), 0 10px 13px -6px rgba(0, 0, 0, 0.20)', // 21
        '0 8px 42px 7px rgba(0, 0, 0, 0.12), 0 22px 35px 3px rgba(0, 0, 0, 0.14), 0 10px 14px -6px rgba(0, 0, 0, 0.20)', // 22
        '0 9px 44px 8px rgba(0, 0, 0, 0.12), 0 23px 36px 3px rgba(0, 0, 0, 0.14), 0 11px 14px -7px rgba(0, 0, 0, 0.20)', // 23
        '0 9px 46px 8px rgba(0, 0, 0, 0.12), 0 24px 38px 3px rgba(0, 0, 0, 0.14), 0 11px 15px -7px rgba(0, 0, 0, 0.20)', // 24
    ],
    components: componentOverrides,
    // spacing = N * 8px (https://material-ui.com/customization/spacing/)
};

// const v4Theme = adaptV4Theme(theme)
export const _theme = environment.production ? createTheme(theme) : unstable_createMuiStrictModeTheme(theme);
